import * as React from 'react';

export default abstract class AbstractLayer extends React.Component {
  abstract props: any;
  public componentDidMount() {
    if (!this.props.layer) { throw new Error("Layer does not implement componentDidMount"); }
  }

  public componentWillUnmount() {
    this.props.layer.mapbox.ids.forEach(id => {
      if (this.props.map.getLayer(id)) { this.props.map.removeLayer(id); }
      if (this.props.map.getSource(id)) { this.props.map.removeSource(id); }
    });
  }

  public componentDidUpdate() {
    const { layer, map } = this.props;
    layer.mapbox.ids.forEach(id => {
      if (map.getLayer(id) && map.getSource(id)) {
        map.setLayoutProperty(id, 'visibility', layer.visible ? 'visible' : 'none');
      }
    });
  }

  public render() { return null; }

  public createMapboxId() {
    /*
    Q: Why does the generated mapbox ID include a timestamp?

    A: When the Layer collection is changed, Layer components will unmount,
    and identical versions may remount. Setting the ID to include the timestamp
    guarantees that the new component and the old component won't have a naming
    collision, in the case that the new component tries to mount before the old
    component succeeds in unmounting.
  */
    return `fybrLayer-${this.props.layer.id}-${performance.now()}`;
  }
}
